/** Shared camera/navigation button treatment across spacecraft and site twins. */
export const twinActionClass =
  'inline-flex min-h-7 items-center justify-center gap-1.5 whitespace-nowrap border border-hairline-strong bg-inset/70 px-2.5 text-[11px] hover:border-accent/50';
